import { useEffect, useState } from "react";

export default function SelecaoSemana() {

    const [selecoes, setSelecoes] = useState([]);

    useEffect(() => {

        carregarSelecoes();

    }, []);

    async function carregarSelecoes(){

        const resposta = await fetch("/api/selecao/ativa");

        const dados = await resposta.json();

        setSelecoes(dados);

    }

    return (

        <div style={{padding:30}}>

            <h1>Seleção da Semana</h1>

            <p>Seleções abertas para votação</p>

            {selecoes.map((s)=>(

                <div
                    key={s._id}
                    style={{
                        border:"1px solid #ddd",
                        borderRadius:12,
                        padding:20,
                        marginBottom:20
                    }}
                >

                    <h2>{s.categoria}</h2>

                    <p>Status: {s.status}</p>

                    <p>Aptos: {s.aptos.length}</p>

                </div>

            ))}

        </div>

    );

}
